// extracted by mini-css-extract-plugin
export default {"sparkle":"SparkleIndicator-module__sparkle___dzPOc"};